import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Amc from "./amc";
import Nav from "./nav";
import MailBack from "./mailBackRequest";
import TransactionHistory from "./transactionHistory";
import Social from "./social";
import Settings from "./settings";
import DashboardComponent from "./dashboard/index";
import InvestorComponent from "./investors/index";
import TransactionComponent from "./transactions/index";
import MailBackComponent from "./mailBackRequest/mailBack";
import MyEarnings from "./myEarnings/index";
import EKYC from "../home/transactions/ekycForm";
import { connect } from "react-redux";
import NFOComponent from "./NFO";
import NewInvestorRegistration from "./transactions/newInvestor/NewInvestorRegistration";
class AppRouter extends Component {
  render() {
    return (
      <Switch>
        <Route
          path={`/new-investor-transaction`}
          component={NewInvestorRegistration}
        />
        <Route path={`/dashboard`} component={DashboardComponent} />
        <Route path={`/settings`} component={Settings} />
        <Route path={`/investors`} component={InvestorComponent} />
        <Route path={`/new-transaction`} component={TransactionComponent} />
        <Route path={`/nfo-funds`} component={NFOComponent} />
        <Route path={`/amc`} component={Amc} />
        <Route path={`/nav`} component={Nav} />
        <Route path={`/mailBackRequest`} exact component={MailBack} />
        <Route
          path={`/mailBackRequest/investor`}
          component={MailBackComponent}
        />
        <Route path={`/transaction-history`} component={TransactionHistory} />
        <Route path={`/my-earnings`} component={MyEarnings} />
        <Route path={`/connectviaSocial`} component={Social} />
        <Route path={`/e-KYC`} component={EKYC} />
        <Route path={`/`} exact>
          {!!this.props.tran_enable_flag &&
          this.props.tran_enable_flag === "N" ? (
            <Redirect to={`/dashboard`} />
          ) : (
            <Redirect to={`/new-transaction`} />
          )}
        </Route>
      </Switch>
    );
  }
}

export default connect(({ authReducer }) => {
  const { tran_enable_flag } = authReducer;
  return {
    tran_enable_flag,
  };
}, null)(AppRouter);
